import {
    Alert,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import { SummaryCard } from "./summary-card"
import { BreakdownRow } from "./breakdown-row"
import { ModifierRuleRow } from "./modifier-rule-row"

export function PreviewSummary({ preview }) {
    return (
        <Stack spacing={2}>
            <Stack direction="row" spacing={3}>
                <SummaryCard label="Total Tasks" value={preview.totalTasks} />
                <SummaryCard label="Included" value={preview.includedTasks} color="success.main" />
                <SummaryCard label="Excluded" value={preview.excludedTasks} color="error.main" />
                <SummaryCard label="Modified" value={preview.modifiedTasks} color="info.main" />
            </Stack>
            <If value={preview.totalTasks > 0 && preview.excludedTasks === preview.totalTasks}>
                <Alert severity="warning">
                    All tasks are excluded by this rule set configuration. No tasks will be included in the scenario.
                </Alert>
            </If>
            <If value={preview.classificationBreakdown && preview.classificationBreakdown.length > 0}>
                <TableContainer sx={{ mt: 2 }}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                        Classification Breakdown
                    </Typography>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Classification</TableCell>
                                <TableCell align="right">Included</TableCell>
                                <TableCell align="right">Excluded</TableCell>
                                <TableCell align="right">Modified</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <Repeat list={preview.classificationBreakdown || []} item={<BreakdownRow />} />
                        </TableBody>
                    </Table>
                </TableContainer>
            </If>
            <If value={preview.modifierRuleBreakdown && preview.modifierRuleBreakdown.length > 0}>
                <TableContainer sx={{ mt: 2 }}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                        Cost Modifier Rules Applied
                    </Typography>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Rule</TableCell>
                                <TableCell align="right">Tasks Affected</TableCell>
                                <TableCell align="right">Impact</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <Repeat list={preview.modifierRuleBreakdown || []} item={<ModifierRuleRow />} />
                        </TableBody>
                    </Table>
                </TableContainer>
            </If>
        </Stack>
    )
}
